import { Box, Typography } from '@mui/material'
import { tokens } from '../../theme'

const Brand = ({ size = 34, showLabel = true }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        borderRadius: size / 3,
        display: 'grid',
        placeItems: 'center',
        background: `linear-gradient(145deg, ${tokens.accentHover}, #17826A)`,
        boxShadow: `0 6px 18px ${tokens.accentSoft}`
      }}
    >
      <Typography
        sx={{
          fontFamily: "'Outfit', sans-serif",
          fontWeight: 700,
          fontSize: size * 0.5,
          lineHeight: 1,
          color: '#04231B'
        }}
      >
        K
      </Typography>
    </Box>
    {showLabel && (
      <Typography
        sx={{
          fontFamily: "'Outfit', sans-serif",
          fontWeight: 600,
          fontSize: '1.0625rem',
          letterSpacing: '-0.01em'
        }}
      >
        Kanban
      </Typography>
    )}
  </Box>
)

export default Brand
